import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Industries from "@/pages/Industries";
import About from "@/pages/About";
import Careers from "@/pages/Careers";
import Insights from "@/pages/Insights";
import Contact from "@/pages/Contact";
import BDPartner from "@/pages/BDPartner";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/about" element={<About />} />
              <Route path="/careers" element={<Careers />} />
              <Route
                path="/careers/business-development-partner-saudi-arabia"
                element={<BDPartner />}
              />
              <Route path="/insights" element={<Insights />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#111116",
              border: "1px solid #24242a",
              color: "#fafafa",
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
      </div>
    </HelmetProvider>
  );
}

export default App;
